import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconActivityWellnessComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        className="lucide lucide-smile"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" fill="none" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" fill="none" />
        <line fill="none" x1="9" x2="9.01" y1="9" y2="9" />
        <line fill="none" x1="15" x2="15.01" y1="9" y2="9" />
      </svg>
    </SvgIcon>
  );
};

IconActivityWellnessComponent.displayName = 'IconActivityWellness';

const IconActivityWellness = React.memo(IconActivityWellnessComponent);

export default IconActivityWellness;
